import PropTypes from "prop-types";
import { Badge } from "@/components/ui/badge";

// Legacy variant names still map; an unknown variant would render an
// invisible badge (cva drops it silently — #32 review).
const BADGE_VARIANTS = {
  primary: "default",
  secondary: "secondary",
  success: "success",
  warning: "warning",
  danger: "destructive",
  info: "secondary",
  light: "secondary",
  dark: "secondary",
};

const PageHeader = ({
  title,
  subtitle,
  badge,
  badgeVariant = "secondary",
  className = "",
}) => {
  const variant = BADGE_VARIANTS[badgeVariant] || badgeVariant;
  // A count of 0 is a badge worth showing ("Your Memories 0"), but `badge &&`
  // renders the NUMBER ZERO as bare text instead — outside the <Badge>, so it
  // loses the pill and the gap and reads as "Your Memories0". Test only for
  // absence (agent QA report, task #26).
  const hasBadge = badge !== null && badge !== undefined && badge !== "";
  return (
    <div className={`mb-6 ${className}`}>
      <h1 className="mb-1 flex items-center font-display text-3xl font-semibold tracking-tight">
        {title}
        {/* A real space so the heading reads "Your Memories 0" to a
            screen reader and to anything scraping textContent. The h1 is
            a flex container, where a whitespace-only text run is not
            rendered — so this costs nothing visually; ml-2 still draws
            the gap. */}
        {hasBadge && " "}
        {hasBadge && (
          <Badge variant={variant} className="ml-2">
            {badge}
          </Badge>
        )}
      </h1>
      {subtitle && <p className="m-0 text-muted-foreground">{subtitle}</p>}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  badgeVariant: PropTypes.string,
  className: PropTypes.string,
};

export default PageHeader;
